export default "__VITE_ASSET__BZGFuySr__"